<ngb-timepicker
  [ngModel]="timePickerModel"
  (ngModelChange)="changeTime($event)"
  [meridian]="!disabled"
  [spinners]="false"
  [readonlyInputs]="disabled || readonly"
>
</ngb-timepicker>
